import * as moment from 'moment';
import { BaseModel } from './common/base-model';
import { AjaxService } from '../services/ajax.service';
import { AppInjector } from '../utility/app-injector';

export interface OrganizationInterface {
    addr_city: string;
    addr_state: string;
    created_at: Date;
    friendly_name: string;
    id: number;
    legal_name: string;
    name: string;
    updated_at: Date;
    logo_uri: string;
}

export class OrganizationModel extends BaseModel{
    ajaxService: AjaxService;
    attributes: OrganizationInterface;
    id: string;

    constructor(data = null) {
        super(data);
        this.ajaxService = AppInjector.get(AjaxService);

        if (!data) {
            return;
        }
    }

    getLogoUrl() {
        return this.ajaxService.getAssetUrl(this.get('logo_uri'));
    }

    getOrganizationName(includeCityState: boolean = false) {
        // Return friendly_name if it exists — otherwise, return name
        let orgDisplay = '';

        if ((this.get('friendly_name') || '').length > 0) {
            orgDisplay = this.get('friendly_name');
        } else {
            orgDisplay = this.get('name');
        }

        if (!includeCityState) {
            return orgDisplay;
        }

        // Format city/state
        let cityState = '';

        if ((this.get('addr_city') || '').length > 0) {
            cityState += this.get('addr_city');
        }

        if ((this.get('addr_state') || '').length > 0) {
            if (cityState.length > 0) {
                cityState += ', ';
            }

            cityState += this.get('addr_state');
        }

        return orgDisplay + (cityState.length > 0 ? ` (${cityState})` : '');
    }
}


// WEBPACK FOOTER //
// ./src/app/models/organization.model.ts